import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import ShowcaseService from "../../services/ShowcaseService";

const CreateNewShowcaseModal = ({ isOpen, setIsOpen, setLoading, refreshShowcases }) => {
  const [showcase, setShowcase] = useState({
    title: "",
    pin: "0000",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setShowcase({ ...showcase, [name]: value });
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const uploadShowcase = () => {
    setLoading(true);
    ShowcaseService.create(showcase)
      .then(() => {
        setLoading(false);
        refreshShowcases();
        setIsOpen(false);
      })
      .catch((e) => {
        window.alert("Error creating showcase");
      });
  };

  return (
    <Modal open={isOpen} onClose={handleClose} className="add-modal">
      <div className="add-modal-content">
        <h3>Create New Showcase</h3>
        <div className="add-name">
          <div style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}>
            <TextField
              style={{ width: 400 }}
              label="Name"
              name="title"
              variant="filled"
              fullWidth
              onChange={handleChange}
            />
            <TextField
              style={{ width: 400 }}
              label="4-digit PIN"
              name="pin"
              variant="filled"
              max
              fullWidth
              onChange={handleChange}
              value={showcase.pin}
              inputProps={{ maxLength: 4 }}
            />
          </div>
          <Button style={{ marginLeft: "15px" }} color="primary" onClick={uploadShowcase}>
            Submit
          </Button>
          <Button style={{ marginRight: "-15px" }} color="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CreateNewShowcaseModal;
